import { render, staticRenderFns } from "./EditSeller.vue?vue&type=template&id=44210643&scoped=true&"
import script from "./EditSeller.vue?vue&type=script&lang=js&"
export * from "./EditSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44210643",
  null
  
)

export default component.exports